import React, { Component } from 'react'
import styled from 'styled-components'
import { Select } from 'advenio-components'
import { Form } from 'formsy-react' //eslint-disable-line
import moment from 'moment'

const Body = styled.div`
  display: block;
  justify-content: center;
  flex:1;
`
const TimerContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex: 1;
`
const NewSelect = styled(Select)`
  margin: 16px;
  width: ${({ large }) => large ? '80px' : '65px'};
  &:first-of-type {
    margin-right: 8px;
  }
`
const Label = styled.span`
  height: 0px;
  width: auto;
  font-size:14px;

`
const hours = [
  // { value: 7, label: '7', id: 7 },
  // { value: 8, label: '8', id: 8 },
  { value: 9, label: '9', id: 9 },
  { value: 10, label: '10', id: 10 },
  { value: 11, label: '11', id: 11 },
  { value: 12, label: '12', id: 12 },
  { value: 13, label: '13', id: 13 },
  { value: 14, label: '14', id: 14 },
  { value: 15, label: '15', id: 15 },
  { value: 16, label: '16', id: 16 },
  { value: 17, label: '17', id: 17 },
  { value: 18, label: '18', id: 18 },
  // { value: 19, label: '19', id: 19 },
  // { value: 20, label: '20', id: 20 },
]

const minutesArry = [
  { value: 0, label: '00', id: '00' },
  { value: 5, label: '05', id: '05' },
  { value: 10, label: '10', id: '10' },
  { value: 15, label: '15', id: '15' },
  { value: 20, label: '20', id: '20' },
  { value: 25, label: '25', id: '25' },
  { value: 30, label: '30', id: '30' },
  { value: 35, label: '35', id: '35' },
  { value: 40, label: '40', id: '40' },
  { value: 45, label: '45', id: '45' },
  { value: 50, label: '50', id: '50' },
  { value: 55, label: '55', id: '55' },
]

const time = [{ value: 'am', label: 'AM', id: 'am' }, { value: 'pm', label: 'PM', id: 'pm' }]

class TimePicker extends Component {
  state = {
    hour: 9,
    minute: '00',
    // ampm: 'am',
    minutes:minutesArry,
  }
  componentWillMount(){
    const { value } = this.props
    const minute = value !== null ? Number(value.match(/[^:][0-9]*$/)[0]) : null 
    const hour = value !== null ? Number(value.match(/^[0-9]*[^:]/)[0]) : null

    if( hour !== null && minute !== null){
      this.setState({hour,minute})
    }
  }

  getTwentyFourHourTime = (date) => {
    const d = moment(date, 'hh:mm a')
    const newHour = Number(d.hours()) < 10 ? this.addZero(d.hours()) : d.hours()
    const newMinute = Number(d.minutes()) < 10 ? this.addZero(d.minutes()) : d.minutes()
    return `${newHour}:${newMinute}`
  }

  getValue = () => {
    const { hour, minute } = this.state
    const timeSelected = `${hour}:${minute}`
    return this.getTwentyFourHourTime(timeSelected)
  }

  handleChange = (value, attribute) => {
    const dataToUpdate = {}
    const { minutes } = this.state
    const newminutes = []
    dataToUpdate[attribute] = value

    // if(Number(value) === 18 && attribute === 'hour'){
    //   console.log(minutes.filter(h => h.value <= 30))
    //   dataToUpdate['minutes'] = minutesArry.filter(m => m.value <= 30)
    // }
    // else if(Number(value) === 13 && attribute === 'hour'){
    //   dataToUpdate['minutes'] = [  { value: 0, label: '00', id: '00' },]
    // }
    // else if(Number(value) === 14 && attribute === 'hour'){
    //   dataToUpdate['minutes'] = minutesArry.filter(m => m.value >= 30)
    // }
    // else if(Number(value) < 18 && attribute === 'hour'){
    //   dataToUpdate['minutes'] = minutesArry
    // }

    this.setState(dataToUpdate)
  }


  addZero = i => i < 10 ? `0${i}` : i


  render() {

    const { label, required,value } = this.props
    // const minute = value !== null ? Number(value.match(/[^:][0-9]*$/)[0]) : null 
    // const hour = value !== null ? Number(value.match(/^[0-9]*[^:]/)[0]) : null
    const {hour, minute, minutes } = this.state
    return (
      <Body>
        <Label>{label}</Label>
        <TimerContainer>
          <NewSelect
            name="hour"
            label="Hora"
            value={hour || hours[1].value}
            options={hours}
            hideEmptyHelpBlock
            onChangeCallback={(e) => { this.handleChange(e.currentTarget.value, 'hour') }}
          />
          <NewSelect
            name="minute"
            label="Minutos"
            value={minute ||minutes[0].value}
            options={minutes}
            hideEmptyHelpBlock
            large
            onChangeCallback={(e) => { this.handleChange(e.currentTarget.value, 'minute') }}
          />
          {/* <NewSelect
            name="ampm"
            label="Periodo"
            value={time[0].value}
            options={time}
            hideEmptyHelpBlock
            onChangeCallback={(e) => { this.handleChange(e.currentTarget.value, 'ampm') }}
          /> */}
        </TimerContainer>
      </Body>
    )
  }
}

export default TimePicker



// WEBPACK FOOTER //
// ./src/shared/TimePicker.jsx